import React, { useRef } from "react";
import LOGO from '../Assets/CFPLOGO.png';
import { AiFillPrinter } from 'react-icons/ai';
import ReactToPrint from "react-to-print";
import Moment from "react-moment";

export default function PrintComponent({ quote }) {
    const componentRef = useRef();

    return (
        <>
            <div style={{ textAlign: 'right', margin: '20px 40px 0 0' }}>
                <ReactToPrint
                    trigger={() => <AiFillPrinter title="Print Quote" style={{ fontSize: "1.8rem", cursor: 'pointer' }} />}
                    content={() => componentRef.current}
                />
            </div>
            <div style={{ display: "none" }}>
                <ComponentToPrint ref={componentRef} quote={quote} />
            </div>
        </>
    );
}

class ComponentToPrint extends React.Component {
    render() {
        const { quote } = this.props;

        if (!quote || !quote.items) {
            return <div>No quote data available</div>;
        }

        const pocketFolders = quote.items.pocketfolder || [];
        const neccItems = quote.items.necc || [];
        const allItems = [...pocketFolders, ...neccItems];

        const itemsPerPage = 4;
        const pages = [];
        for (let i = 0; i < allItems.length; i += itemsPerPage) {
            pages.push(allItems.slice(i, i + itemsPerPage));
        }

        const renderHeader = () => (
            <div style={{ display: 'flex', marginBottom: '30px' }}>
                <div style={{ display: 'flex', flex: '1', justifyContent: 'space-between', alignItems: 'flex-start', flexDirection: 'column' }}>
                    <div>
                        <img src={LOGO} style={{ height: "80px" }} alt="CFP Logo" />
                    </div>

                    <div style={{ textAlign: 'right', fontSize: '.7rem', marginLeft: '33px' }}>
                        4250 118th Ave N<br />
                        Clearwater, FL 33762<br />
                        Phone (727) 572-8088<br />
                        Fax: (727) 573-2662
                    </div>
                </div>

                <div style={{ flex: '1', textAlign: 'center', position: 'relative' }}>
                    <span style={{ fontSize: '1.4rem' }}>Quote Request</span>
                    <div style={{ marginTop: '0px', fontSize: '.7rem' }}>
                        <br />
                        <u style={{ fontSize: '1rem' }}>Requested By</u><br />
                        <span style={{ fontSize: '.9rem' }}>{quote.customer?.name}</span><br />
                        {quote.billTo?.address1} {quote.billTo?.address2}<br />
                        {quote.billTo?.city}, {quote.billTo?.state} {quote.billTo?.zip}<br />
                        {quote.customer?.phone && <>{quote.customer?.phone}</>}<br />
                    </div>
                </div>

                <div style={{ flex: '1', textAlign: 'center' }}>
                    <div style={{ fontSize: '.9rem', marginTop: '60px' }}>
                        Date: <Moment format="MM/DD/YYYY">{quote.createdAt}</Moment><br /><br /><br />
                        Quote #: {quote.quotenum}
                    </div>
                </div>
            </div>
        );

        const renderItem = (item, globalIndex) => {
            const isPocketFolder = pocketFolders.includes(item) || item.finishingType === 'pocketFolder';

            let desc = `${item.width || '??'}" × ${item.length || '??'}" `;

            if (isPocketFolder) {
                desc += 'Pocket Folder';

                if (item.numPockets) {
                    desc += ` – ${item.numPockets} Pocket${item.numPockets > 1 ? 's' : ''}`;
                }

                const heights = [];
                if (item.pocketTabs?.pocket1?.height > 0) heights.push(`${item.pocketTabs.pocket1.height}"`);
                if (item.numPockets === 2 && item.pocketTabs?.pocket2?.height > 0) heights.push(`${item.pocketTabs.pocket2.height}"`);
                if (heights.length > 0) {
                    desc += ` (Pockets: ${heights.join(' / ')})`;
                }

                if (item.glueTapingMode === 'auto') desc += ' – Auto Glue';
                else if (item.glueTapingMode === 'hand') desc += ' – Hand Glue';
                else if (item.glueTapingMode === 'taping') desc += ' – Taping';

                if (item.folding > 0) desc += ` – ${item.folding} Fold${item.folding > 1 ? 's' : ''}`;

                if (item.stripping) desc += ' – Stripping';
            } else {
                const ops = [];
                if (item.dieCut) ops.push('Die Cut');
                if (item.perf) ops.push('Perf');
                if (item.score) ops.push('Score');
                if (ops.length > 0) desc += ops.join(' + ');
                if (item.stripping) desc += ' – Stripping';
            }

            const specials = [];
            if (item.emboss?.state) specials.push('Emboss');
            if (item.deboss?.state) specials.push('Deboss');
            if (item.foil?.state) {
                const colors = item.foil.plates.map(p => p.color || 'Gold').join('/');
                specials.push(`Foil (${colors})`);
            }
            if (specials.length > 0) desc += ` – ${specials.join(' + ')}`;

            const quantities = item.quantities || [];
            const chunks = [];
            for (let i = 0; i < quantities.length; i += 6) {
                chunks.push(quantities.slice(i, i + 6));
            }

            return (
                <div style={{ marginBottom: '35px', pageBreakInside: 'avoid' }}>
                    <div style={{
                        fontSize: '0.9rem',
                        fontWeight: 'bold',
                        color: '#1565c0',
                        marginBottom: '12px',
                        paddingBottom: '5px',
                        borderBottom: '1px solid #1565c0'
                    }}>
                        Item {globalIndex}: {desc}
                    </div>

                    {chunks.map((chunk, chunkIndex) => (
                        <div key={chunkIndex} style={{ display: 'flex', gap: '35px', justifyContent: 'flex-start', marginBottom: '8px' }}>
                            {chunk.map((q, i) => (
                                <div key={i} style={{ textAlign: 'center', minWidth: '105px' }}>
                                    <div style={{
                                        fontSize: '0.8rem',
                                        fontWeight: 'bold',
                                        color: '#1565c0',
                                        textDecoration: 'underline',
                                        marginBottom: '3px'
                                    }}>
                                        {Number(q.quantity || 0).toLocaleString()}
                                    </div>
                                    <div style={{
                                        fontSize: '0.9rem',
                                        fontWeight: 'bold',
                                        color: '#2e7d32'
                                    }}>
                                        ${Number(q.totalPrice || 0).toFixed(2)}
                                    </div>
                                    {q.totalPieces && (
                                        <div style={{
                                            fontSize: '0.7rem',
                                            color: '#555',
                                            marginTop: '3px'
                                        }}>
                                            ({q.totalPieces.toLocaleString()} pcs)
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            );
        };

        return (
            <div style={{ fontFamily: 'Arial, sans-serif' }}>
                {pages.map((pageItems, pageIndex) => {
                    const isFirstPage = pageIndex === 0;
                    const isLastPage = pageIndex === pages.length - 1;
                    const startIndex = pageIndex * itemsPerPage + 1;

                    return (
                        <div
                            key={pageIndex}
                            style={{
                                padding: '20px 40px',
                                position: 'relative',
                                minHeight: '100vh',
                                pageBreakAfter: isLastPage ? 'auto' : 'always'
                            }}
                        >
                            {/* Header on every page */}
                            {renderHeader()}

                            <hr style={{ borderTop: "2px solid black", margin: "3px 0 10px 3px" }} />

                            {/* Job Name and Cust Job# only on first page */}
                            {isFirstPage && (
                                <>
                                    <div style={{ fontSize: '1rem' }}>
                                        <span style={{ fontSize: '1rem' }}>PROJECT NAME: </span>&nbsp;{quote.jobName || 'N/A'}
                                    </div>
                                    <div style={{ fontSize: '1rem', marginBottom: '30px' }}>
                                        <span style={{ fontSize: '1rem' }}>CUST JOB#: </span>{quote.customerJobNumber || 'N/A'}
                                    </div>
                                </>
                            )}

                            {/* Project Summary Title only on first page */}
                            {isFirstPage && (
                                <div style={{
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                    color: '#1565c0',
                                    textAlign: 'center',
                                    margin: '0 0 20px 0'
                                }}>
                                    Project Summary
                                </div>
                            )}

                            {/* Items for this page */}
                            <div style={{
                                backgroundColor: '#f8fdff',
                                padding: '25px',
                                borderRadius: '10px',
                                border: '1px solid #bbdefb'
                            }}>
                                {pageItems.map((item, idx) => renderItem(item, startIndex + idx))}
                            </div>

                            {/* Terms & Conditions only on last page */}
                            {isLastPage && (
                                <div style={{
                                    position: 'absolute',
                                    bottom: "100px",
                                    left: "40px",
                                    right: "40px",
                                    fontSize: ".7rem",
                                    lineHeight: "1.7",
                                    color: "#444"
                                }}>
                                    <strong style={{ fontSize: '.9rem' }}>We look forward to working with you!</strong><br /><br />
                                    <strong>Terms & Conditions:</strong><br />
                                    • Prices valid for 30 days • Freight not included<br />
                                    • 50% deposit required on new dies • Artwork must be press-ready PDF<br /><br />
                                </div>
                            )}

                            {/* Company Footer - Fixed at bottom of every page */}
                            <div style={{
                                position: 'fixed',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                padding: '12px 0',
                                textAlign: 'center',
                                color: '#555',
                                fontSize: '0.75rem',
                                backgroundColor: '#f5f5f5',
                                borderTop: '1px solid #ddd'
                            }}>
                                <em>Clearwater Finishing & Packaging • Clearwater, FL • (727) 572-8088 • quotes@cfpprint.com</em>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}